import React from 'react';
import { Calendar, Tag, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { promociones } from '../utils/mockData';

const Promociones = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <section className="bg-gradient-to-r from-[#1e3a8a] to-[#1e40af] text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Promociones</h1>
          <p className="text-xl opacity-90">Aprovecha nuestras ofertas especiales</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 py-12">
        {/* Featured promo */}
        <div className="mb-12">
          <Card className="bg-gradient-to-r from-red-500 to-pink-600 text-white shadow-2xl overflow-hidden">
            <CardContent className="p-0">
              <div className="grid md:grid-cols-2 gap-0">
                <div className="p-12 flex flex-col justify-center">
                  <div className="inline-block bg-white text-pink-600 px-4 py-2 rounded-full text-sm font-bold mb-6 w-fit">
                    PROMOCIÓN DESTACADA
                  </div>
                  <div className="text-7xl md:text-8xl font-bold mb-4">
                    30<span className="text-4xl">%*</span>
                  </div>
                  <p className="text-2xl mb-2">de descuento</p>
                  <h2 className="text-3xl md:text-4xl font-bold mb-4">
                    Perfiles de salud completos
                  </h2>
                  <p className="text-lg opacity-90 mb-6">
                    Aprovecha esta promoción en todos nuestros paquetes de salud integral
                  </p>
                  <Button className="bg-white text-pink-600 hover:bg-gray-100 w-fit px-8 py-6 text-lg">
                    Conoce más
                  </Button>
                  <p className="text-xs mt-4 opacity-75">*Válido hasta el 30 de abril de 2026. Aplican restricciones.</p>
                </div>
                <div className="relative h-96 md:h-auto">
                  <img 
                    src={promociones[0].imagen}
                    alt="Promoción"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Promociones grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {promociones.map((promo) => (
            <Card key={promo.id} className="group hover:shadow-xl transition-all duration-300 overflow-hidden">
              <div className="relative h-64">
                <img 
                  src={promo.imagen}
                  alt={promo.titulo}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
                {promo.descuento > 0 && (
                  <div className="absolute top-4 right-4 bg-red-500 text-white px-4 py-2 rounded-full font-bold text-xl shadow-lg">
                    -{promo.descuento}%
                  </div>
                )}
              </div>
              <CardContent className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <Tag className="h-4 w-4 text-[#84cc16]" />
                  <span className="text-sm font-semibold text-[#84cc16]">PROMOCIÓN ACTIVA</span>
                </div>
                <h3 className="text-2xl font-bold text-[#1e3a8a] mb-2">
                  {promo.titulo}
                </h3>
                <p className="text-lg font-semibold text-[#1e40af] mb-3">
                  {promo.subtitulo}
                </p>
                <p className="text-gray-600 mb-4">{promo.descripcion}</p>
                
                <div className="flex items-center gap-2 text-sm text-gray-500 mb-4">
                  <Calendar className="h-4 w-4" />
                  <span>Válido hasta: {new Date(promo.validoHasta).toLocaleDateString('es-MX')}</span>
                </div>

                <Button className="w-full bg-[#84cc16] hover:bg-[#65a30d] text-white">
                  Ver detalles <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Info section */}
        <div className="mt-12 bg-white rounded-lg shadow-md p-8">
          <h3 className="text-2xl font-bold text-[#1e3a8a] mb-4">Términos y condiciones</h3>
          <ul className="space-y-2 text-gray-600">
            <li className="flex items-start gap-2">
              <span className="text-[#84cc16] font-bold mt-1">•</span>
              <span>Las promociones no son acumulables con otros descuentos.</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[#84cc16] font-bold mt-1">•</span>
              <span>Aplican restricciones según el tipo de estudio.</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[#84cc16] font-bold mt-1">•</span>
              <span>Consulta disponibilidad en tu sucursal más cercana.</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[#84cc16] font-bold mt-1">•</span>
              <span>Vigencia sujeta a cambios sin previo aviso.</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Promociones;